import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter, Routes, Route } from "react-router-dom";
import Login from "./App";
import Signup from "./pages/Signup";
// import "./index.css";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import ProfilePage from "./pages/Profile";
import ChallengesPage from "./pages/Challenges";
import Mappage from "./pages/map";
import UserSettings from "./pages/Settings";
import TeamManagement from "./components/tean/TeamManagement";

export default function App() {
  return (
    <HashRouter>
      <Routes>
        <Route index element={<Login />} />
        <Route path="signup" element={<Signup />} />
        <Route path="home" element={<Home />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path='profile' element={<ProfilePage />} />
        <Route path="challenges" element={<ChallengesPage />} />
        <Route path="map" element={<Mappage />} />
        <Route path="settings" element={<UserSettings />} />
        <Route path="teams" element={<TeamManagement />} />
      </Routes>
    </HashRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
